
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import Signup from "../pages/signup/page";
import ParserCreation from "../pages/parser-creation/page";
import CreateNew from "../pages/create-new/page";
import CreateFromExisting from "../pages/create-from-existing/page";
import Templates from "../pages/templates/page";
import AirWaybillTemplate from "../pages/templates/air-waybill/page";
import InvoiceTemplate from "../pages/templates/invoice/page";
import PurchaseOrderTemplate from "../pages/templates/purchase-order/page";
import BillOfLadingTemplate from "../pages/templates/bill-of-lading/page";
import Playground from "../pages/playground/page";
import AdminPanel from "../pages/admin-panel/page";
import AdminMaster from "../pages/admin-master/page";
import UserManagement from "../pages/user-management/page";
import ReservedFormats from "../pages/reserved-formats/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/parser-creation",
    element: <ParserCreation />,
  },
  {
    path: "/create-new",
    element: <CreateNew />,
  },
  {
    path: "/create-from-existing",
    element: <CreateFromExisting />,
  },
  {
    path: "/templates",
    element: <Templates />,
  },
  {
    path: "/templates/air-waybill",
    element: <AirWaybillTemplate />,
  },
  {
    path: "/templates/invoice",
    element: <InvoiceTemplate />,
  },
  {
    path: "/templates/purchase-order",
    element: <PurchaseOrderTemplate />,
  },
  {
    path: "/templates/bill-of-lading",
    element: <BillOfLadingTemplate />,
  },
  {
    path: "/playground",
    element: <Playground />,
  },
  {
    path: "/admin-panel",
    element: <AdminPanel />,
  },
  {
    path: "/admin-master",
    element: <AdminMaster />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
  {
    path: "/reserved-formats",
    element: <ReservedFormats />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
